import React, { useRef } from 'react';
import ReactInputMask, { Props as InputProps } from 'react-input-mask';

import { useField } from 'formik';

import { Container } from './styles';

export type InputMaskProps = Omit<InputProps, 'defaultValue'> & {
  name: string;
  label?: string;
  optional?: boolean;
  isRequired?: boolean;
};

const InputMask: React.FC<InputMaskProps> = ({
  name,
  label = null,
  optional = false,
  value: inputValue,
  onChange: inputOnChange,
  isRequired,
  ...rest
}) => {
  const [field, meta, helpers] = useField<string | undefined>(name);
  const { value } = field;
  const { error } = meta;
  const { setValue } = helpers;

  const inputRef = useRef(null);

  const handleChangeValue = (newValue?: string) => {
    if (newValue && newValue.length > 0) {
      setValue(newValue);
    } else {
      setValue(undefined);
    }
  };

  return (
    <Container isRequired={isRequired}>
      {(label || optional) && (
        <div>
          {label && <label htmlFor={name}>{label}</label>}{' '}
          {optional && <small>(opcional)</small>}
        </div>
      )}
      <div>
        <ReactInputMask
          ref={inputRef}
          value={inputValue ?? value}
          onChange={(e) => {
            handleChangeValue(e.target.value);
            if (inputOnChange) inputOnChange(e);
          }}
          {...rest}
        />
      </div>
      {error && <span>{error}</span>}
    </Container>
  );
};

export default InputMask;
